import { HtsReadinessPillarKey } from "../constants";
import { HtsReadinessPillarConfig } from "../schemas";

export const leadership: HtsReadinessPillarConfig = {
  key: HtsReadinessPillarKey.LEADERSHIP,
  label: "Leadership",
  definition:
    "The ability to make sound decisions under pressure and guide others in high-stress situations, demonstrated through employment, volunteer, or extracurricular activities. This rubric deliberately weights demonstrated behaviour above titles.",
  dataSourceNote:
    "Asked — one open question about leadership or supervisory roles, formal or informal: the role, its duration, and what they actually did.",
  dimensions: [
    {
      key: "demonstratedLeadershipBehaviours",
      label: "Demonstrated Leadership Behaviours",
      weight: 0.55,
      anchors: {
        0: "Title only, or only helping coworkers with simple questions (where things are, how a task is done).",
        25: "Basic task coordination: assigning shifts or tasks to others.",
        50: "Directed others' work with some ownership of outcomes.",
        75: "Concrete examples of guiding others through difficulty: a conflict handled, a struggling teammate developed, a call made under pressure.",
        100: "Multiple specific examples of leading people through pressure or stress, with outcomes and lessons the candidate can articulate.",
      },
    },
    {
      key: "formalityOfRole",
      label: "Formality of Role",
      weight: 0.2,
      anchors: {
        0: "No leadership exposure of any kind, or only helping coworkers with simple questions (where things are, how a task is done).",
        25: "Exposure to leadership in work or personal life without holding a role.",
        50: "Stepped forward informally (led a project, captained a pickup team, organized an initiative).",
        75: "A temporary designated leadership or supervisory role.",
        100: "A recognized, ongoing designated role — supervisor, manager, coach, or mentor.",
      },
    },
    {
      key: "durationGrowth",
      label: "Duration & Growth",
      weight: 0.25,
      anchors: {
        0: "Not applicable — nothing to measure, including when the only evidence is helping coworkers with simple questions.",
        25: "A single brief episode (days or weeks).",
        50: "Months in a role, or several short episodes.",
        75: "Sustained leadership across a substantial share of the candidate's working history, or clear progression across roles.",
        100: "Sustained leadership across most of the candidate's working history, with increasing scope.",
      },
    },
  ],
  topIndicators: [
    "A story about a hard conversation",
    "A designated role someone chose them for",
    "Scope that grew",
  ],
  scoringNotes: [
    "Answering simple questions from coworkers scores 0 on all three dimensions. Only directing others' work, or guiding someone through a difficulty, counts.",
    "Youth-appropriate evidence counts fully at every anchor — a rep-team captain who managed a locker-room conflict scores on what they did, not on the setting.",
    "Leadership claims are cross-checked against Work Experience's promotion field and Community Contribution's roles; unexplained contradiction becomes a coach note.",
    "Duration is scored relative to years in the workforce since age 18, not in absolute years. Two years of leadership in a four-year working history scores higher than two years in a fifteen-year history.",
  ],
};
